import { render, staticRenderFns } from "./MasterAllExams.vue?vue&type=template&id=29f008f0"
import script from "./MasterAllExams.vue?vue&type=script&lang=js"
export * from "./MasterAllExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports